export const APP_VERSION = 'v1.7.6';
export const APP_PROD_VERSION = 'v1.0.5';
